import { useQuery } from '@tanstack/react-query';
import { ContractSource, Membership } from '../@types/membership';
import { getMembership } from '../api/membership/getMembership';

export const useMembership = (): {
  initializing: boolean;
  contractSource?: ContractSource;
  remainingValuations?: number;
  isBuyerPlus?: boolean;
  isMembershipError?: boolean;
  realEstateProofRequestedAt?: string;
  realEstateDamageReportRequestedAt?: string;
} => {
  const { isLoading, isFetching, data, isError } = useQuery<Membership, Error>({
    queryKey: ['membership'],
    queryFn: getMembership,
  });

  return {
    initializing: isLoading || isFetching,
    contractSource: data?.contractSource,
    remainingValuations: data?.valuationStatus.valuationsLeft,
    isBuyerPlus: data?.entitlements.buyerPlus,
    isMembershipError: isError,
    realEstateProofRequestedAt: data?.realEstateProofRequestedAt,
    realEstateDamageReportRequestedAt: data?.realEstateDamageReportRequestedAt,
  };
};
